import styled, { css } from "styled-components";
import { shade } from "polished";

interface activeProps {
  active: boolean;
}

export const Container = styled.div`
  grid-area: sidebar;
  height: 100vh;
  width: var(--sidebar_width);
  position: fixed;
`;

export const SideBarContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #eeeeee;
  margin: 1px;
  align-items: center;
  cursor: pointer;
  img {
    width: 90%;
    margin-bottom: 50px;
    padding: 5%;
  }
`;

export const ItemMenu = styled.div<activeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: solid 1px grey;

  ${(props) =>
    props.active &&
    css`
      background-color: var(--red);
      border: none;
    `}

  > a {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    vertical-align: middle;
    width: 100%;
  }

  > a > p {
    margin-top: 10px;
    color: var(--purple);
    vertical-align: middle;
    text-align: center;
    font-size: 20px;

    ${(props) =>
      props.active &&
      css`
        color: #fff;
      `}
  }

  &:hover {
    background: ${shade(0.1, "#1f0075")};

    > a > p {
      color: #fff;
    }
  }
`;
